import type { LoanDetails } from '../../generated-types';

const fixedLoans = ['ANNUITY_FIXED', 'FIXED_LOAN', 'SERIAL_FIXED'];

export default (loanDetails?: LoanDetails) => {
    if (!loanDetails) {
        return false;
    }

    return fixedLoans.includes(loanDetails.loanCategory);
};
